import { AboutUsComponent } from "./about-us/about-us.component";
import { FeaturesComponent } from "./features/features.component";
import { LandingPageComponent } from "./landing-page.component";
import { ProjectComponent } from "./project/project.component";
import { RevolutionSliderComponent } from "./revolution-slider/revolution-slider.component";
import { OwlModule } from "ngx-owl-carousel";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "src/app/shared/shared.module";
const routes: Routes = [
    { path: '', component: LandingPageComponent }
  ];
@NgModule({
    declarations: [
        LandingPageComponent,
        RevolutionSliderComponent,
        ProjectComponent,
        FeaturesComponent,
        AboutUsComponent
    ],
    imports: [
        HttpClientModule,
        CommonModule,
        OwlModule,
        RouterModule,
        SharedModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        RouterModule.forChild(routes)

    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports: [
        LandingPageComponent
      ]
  })
  export class LandingModule { }
  export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }